import React from 'react';
import MemberRibbonsGrid from '../../../shared/MemberRibbonsGrid';
import { useDashboardRibbonsAccess } from '../useDashboardRibbonsAccess';

export default function RibbonsCard({
  handleId,
  player,
  loading: profileLoading,
  dashboardClusterScope = false,
}) {
  const hid = Number(handleId);
  const hidOk = Number.isInteger(hid) && hid >= 1;
  const { canSeeAllRibbons } = useDashboardRibbonsAccess(player);
  const ribbonScope = dashboardClusterScope ? 'cluster' : 'handle';

  if (!hidOk) return null;

  if (profileLoading && !player) {
    return (
      <section
        className="member-dashboard__panel-card member-dashboard__ribbons-card"
        aria-busy="true"
        aria-label="Ribbons"
        data-resource="private.navbar.personalhub.ribbons"
        data-action="read"
        data-description="Personal hub — member ribbons"
      >
        <div className="member-dashboard__panel-card-head">
          <h2 className="member-dashboard__panel-title">Ribbons</h2>
        </div>
        <div className="member-dashboard__panel-card-body">
          <p className="member-dashboard__panel-placeholder">Loading…</p>
        </div>
      </section>
    );
  }

  return (
    <section
      className="member-dashboard__panel-card member-dashboard__ribbons-card"
      aria-label="Ribbons"
      data-resource="private.navbar.personalhub.ribbons"
      data-action="read"
      data-description="Personal hub — member ribbons"
    >
      <div
        className="display-none"
        data-resource="private.navbar.personalhub.ribbons"
        data-action="read"
        data-route="/api/user/roster-file-ribbons"
        data-description="Personal hub — ribbons API"
      />

      <MemberRibbonsGrid
        variant="dashboard"
        panelTitle="Ribbons"
        handleId={hid}
        scope={ribbonScope}
        canSeeAllRibbons={canSeeAllRibbons}
      />
    </section>
  );
}
